import React from 'react';
import { MailIcon, PhoneIcon } from 'lucide-react';
import { ButtonLink } from './ButtonLink';
import { DottedRing } from './DottedRing';
import { contact } from '../../data/site';
type CtaBandProps = {
  title: React.ReactNode;
  text: string;
  to: string;
  label: string;
};
export function CtaBand({
  title,
  text,
  to,
  label
}: CtaBandProps) {
  return <section className="w-full bg-brand text-paper" data-id="element-235" data-mp="zzr94p5ly6tz">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-5 py-20 md:px-10 lg:grid-cols-12 lg:items-center lg:py-24" data-id="element-236" data-mp="v30rhxe5n36g">
        <div className="lg:col-span-7" data-id="element-237" data-mp="qzm2ih88ncgv">
          <h2 className="font-serif text-5xl leading-[1.02] tracking-tight md:text-7xl" data-id="element-238" data-mp="m22pfkna15qi">{title}</h2>
          <p className="mt-6 max-w-md text-lg leading-relaxed text-paper/90" data-id="element-239" data-mp="h2zjzz3dwxi0">{text}</p>
          <ButtonLink to={to} variant="ink" arrow className="mt-10 px-8 py-4" data-id="element-240" data-mp="h5c9cxbh2a53">
            {label}
          </ButtonLink>
        </div>

        <div className="flex flex-col items-center lg:col-span-4 lg:col-start-9" data-id="element-241" data-mp="2bgqybbwns5js">
          <DottedRing className="w-60 text-paper/90 md:w-64" data-id="element-242" data-mp="2p6bomghyafmu">
            <p className="font-serif text-3xl text-paper" data-id="element-243" data-mp="2p86co3oiqnv5">Bas Menninga</p>
            <p className="mt-2 font-serif text-sm font-semibold italic text-paper" data-id="element-244" data-mp="2t8ggb9ou926u">muzikant en docent</p>
          </DottedRing>
          <div className="mt-8 space-y-2 text-center text-[17px]" data-id="element-245" data-mp="2fa0d3sq6pttg">
            <a href={contact.phoneHref} className="flex items-center justify-center gap-3 hover:underline" data-id="element-246" data-mp="2k7s1wdvj8ztf">
              <PhoneIcon aria-hidden className="h-4 w-4" data-id="element-247" data-mp="37x38ibzkdofh" />
              {contact.phone}
            </a>
            <a href={`mailto:${contact.email}`} className="flex items-center justify-center gap-3 hover:underline" data-id="element-248" data-mp="3cv4miii4uxk3">
              <MailIcon aria-hidden className="h-4 w-4" data-id="element-249" data-mp="2y4nol94pipry" />
              {contact.email}
            </a>
          </div>
        </div>
      </div>
    </section>;
}